<mat-toolbar *ngIf="(isLogged$ | async)">
  <div class="menu">
    <!-- <button mat-icon-button (click)="openCloseSidenav()">
      <mat-icon>menu</mat-icon>
    </button> -->
    <span>My App</span>
  </div>
  <div>
    <button mat-icon-button>
      <mat-icon>search</mat-icon>
    </button>
    <button mat-icon-button (click)="toggleTheme()">
      <mat-icon *ngIf="(activeTheme$ | async) === 'dark'; else dark">light_mode</mat-icon>
        <ng-template #dark>
          <mat-icon>dark_mode</mat-icon>
        </ng-template>
    </button>
  </div>
</mat-toolbar>

